import { useCallback } from "react";
import { LessonProgress } from "../utils/lessonProgressStorage";
import { useDeviceProgress } from "./useDeviceProgress";

export function useLessonProgress() {
    const { data: progress, update, syncStatus } = useDeviceProgress<LessonProgress>("lessonProgress");
    const setLearned = useCallback((key: string, learned: boolean) => {
        return update(learned ? { kind: "set", key, value: "learned" } : { kind: "remove", key });
    }, [update]);
    return { progress, setLearned, syncStatus };
}
